var devices = {};

devices = {
  sing: "Abstimmgerät",
  plu: "Abstimmgeräte",
  h_plu: "Übersicht - Abstimmgeräte",
}

export default devices;